/**
 * useUnifiedLogout — the one sign-out every surface uses (profile page, trainer menu, mobile
 * bar), so they never drift. Web2: clears the account session and signs out of Supabase. No
 * wallet provider is mounted any more, so there is no wallet to disconnect; the multi-chain
 * teardown this used to do is parked with the wallet logins (auth/web3/).
 */
import { useAccountId } from './useAccountId';

export function useUnifiedLogout(): () => void {
  return useAccountId().logout;
}
